/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Chip,
  Paper,
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
  Alert,
  Autocomplete,
  MenuItem,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItemText,
  Divider,
} from "@mui/material";
import {
  DragDropContext,
  Droppable,
  Draggable,
} from "@hello-pangea/dnd";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import RefreshIcon from "@mui/icons-material/Refresh";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import TableChartIcon from "@mui/icons-material/TableChart";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import TableViewIcon from "@mui/icons-material/TableView";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import DescriptionIcon from "@mui/icons-material/Description";
import TuneIcon from "@mui/icons-material/Tune";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import firebase from "../../../config/firebase";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as XLSX from "xlsx";
import NewMiniDrawer from "../../../components/navMenu/menu-nav";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import appTheme from "../../../theme";

// Lista de tabelas disponíveis no sistema
const AVAILABLE_TABLES = [
  { id: "freight", name: "Fretes", collection: "freight" },
//   { id: "product", name: "Produtos", collection: "product" },
//   { id: "client", name: "Clientes", collection: "client" },
  { id: "drivers_users", name: "Motoristas", collection: "drivers_users" },
  { id: "payment", name: "Pagamentos", collection: "payment" },
//   { id: "user_web", name: "Usuários", collection: "user_web" },
//   { id: "shipper", name: "Embarcadores", collection: "shipper" },
//   { id: "mdfe", name: "MDF-e", collection: "mdfe" },
];

/** Campo usado no filtro de data do relatório (coleta — primeira entrega). */
const DATE_FILTER_FIELD_PATH = "firstDelivery.dateColeta";

/** Prefixos para draggableId únicos no mesmo DragDropContext (@hello-pangea/dnd). */
const DND_POOL_PREFIX = "pool__";
const DND_SEL_PREFIX = "sel__";

const poolDraggableId = (fieldId) => `${DND_POOL_PREFIX}${fieldId}`;
const selDraggableId = (fieldId) => `${DND_SEL_PREFIX}${fieldId}`;

const parseFieldIdFromDraggable = (draggableId) => {
  if (typeof draggableId !== "string") return String(draggableId);
  if (draggableId.startsWith(DND_POOL_PREFIX)) return draggableId.slice(DND_POOL_PREFIX.length);
  if (draggableId.startsWith(DND_SEL_PREFIX)) return draggableId.slice(DND_SEL_PREFIX.length);
  return draggableId;
};

const SAVED_REPORTS_STORAGE_SUFFIX = "relGeneralSavedReports";

const sectionCardSx = {
  borderRadius: `${appTheme.radius.large}px`,
  boxShadow: appTheme.elevation.base,
  backgroundColor: appTheme.colors.surface,
};

const pageLayoutSx = {
  p: `${appTheme.spacing.lg}px`,
  backgroundColor: appTheme.colors.background,
  fontFamily: appTheme.typography.fontFamily,
};

function RelGeneral() {

  const user = useSelector((state) => state.user);
  const userLogado = useSelector((state) => state.usuarioLogado);
  const [tables, setTables] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedTable, setExpandedTable] = useState(null);
  const [tableSearchTerms, setTableSearchTerms] = useState({});
  const [reportTitle, setReportTitle] = useState("Relatório Dinâmico");
  const [error, setError] = useState(null);

  // Filtros
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [selectedFreight, setSelectedFreight] = useState(null);
  const [selectedShipper, setSelectedShipper] = useState(null);
  const [selectedDateOperator, setSelectedDateOperator] = useState("equals");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDateEnd, setSelectedDateEnd] = useState("");
  const [drivers, setDrivers] = useState([]);
  const [freights, setFreights] = useState([]);
  const [shippers, setShippers] = useState([]);
  // Listas completas para restaurar quando necessário
  const [allFreights, setAllFreights] = useState([]);
  const [allShippers, setAllShippers] = useState([]);

  const [savedReportsMenuAnchor, setSavedReportsMenuAnchor] = useState(null);
  const [savedReports, setSavedReports] = useState([]);
  const [saveReportDialogOpen, setSaveReportDialogOpen] = useState(false);
  const [saveReportNameInput, setSaveReportNameInput] = useState("");
  const [savedReportNotice, setSavedReportNotice] = useState(null);

  useEffect(() => {
    loadTablesData();
    loadFiltersData();
  }, []);

  useEffect(() => {
    if (!user?.uid) {
      setSavedReports([]);
      return;
    }
    try {
      const raw = localStorage.getItem(`${user.uid}:${SAVED_REPORTS_STORAGE_SUFFIX}`);
      if (!raw) {
        setSavedReports([]);
        return;
      }
      const parsed = JSON.parse(raw);
      setSavedReports(Array.isArray(parsed) ? parsed : []);
    } catch (e) {
      console.error("Erro ao carregar relatórios salvos:", e);
      setSavedReports([]);
    }
  }, [user?.uid]);

  const toOptionLabel = (value) => {
    if (value === null || value === undefined) {
      return "";
    }
    return String(value).toUpperCase();
  };

  const dedupeById = (items) => {
    const seen = new Set();
    return (items || []).filter((item) => {
      const key = item?.id || JSON.stringify(item);
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
  };

  /* formatação br */
  const toLocalYmd = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const toIsoDate = (value) => {
    if (!value) return null;

    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      return value.trim();
    }

    if (typeof value?.toDate === "function") {
      const converted = value.toDate();
      if (!Number.isNaN(converted.getTime())) {
        return toLocalYmd(converted);
      }
      return null;
    }

    if (typeof value === "object" && typeof value?.seconds === "number") {
      const converted = new Date(value.seconds * 1000);
      if (!Number.isNaN(converted.getTime())) {
        return toLocalYmd(converted);
      }
      return null;
    }

    const converted = new Date(value);
    if (!Number.isNaN(converted.getTime())) {
      return toLocalYmd(converted);
    }

    return null;
  };

  const getNestedValue = (obj, path) => {
    if (!path) return null;
    return path.split(".").reduce((current, key) => {
      return current && current[key] !== undefined ? current[key] : null;
    }, obj);
  };

  const getDocumentFilterDate = (doc) => {
    const raw = getNestedValue(doc, DATE_FILTER_FIELD_PATH);
    return toIsoDate(raw);
  };

  const hasActiveDateFilter =
    selectedDateOperator === "between"
      ? Boolean(selectedDate && selectedDateEnd)
      : Boolean(selectedDate);

  const ensureDateFilterReady = () => {
    if (selectedDateOperator === "between" && (!selectedDate || !selectedDateEnd)) {
      alert('Para o filtro "Entre", informe a data inicial e a data final.');
      return false;
    }
    return true;
  };

  const matchesDateFilter = (doc) => {
    if (!hasActiveDateFilter) return true;

    const docDate = getDocumentFilterDate(doc);
    if (!docDate) return false;

    switch (selectedDateOperator) {
      case "before":
        return docDate < selectedDate;
      case "after":
        return docDate > selectedDate;
      case "between": {
        const start = selectedDate <= selectedDateEnd ? selectedDate : selectedDateEnd;
        const end = selectedDate >= selectedDateEnd ? selectedDate : selectedDateEnd;
        return docDate >= start && docDate <= end;
      }
      case "equals":
      default:
        return docDate === selectedDate;
    }
  };

  const loadFiltersData = async () => {
    try {
      // Carrega motoristas
      await loadDrivers();
      // Carrega fretes
      await loadFreights();
      // Carrega embarcadores
      await loadShippers();
    } catch (err) {
      console.error("Erro ao carregar dados dos filtros:", err);
    }
  };

  const loadDrivers = async () => {
    try {
      let query = firebase.firestore().collection("drivers_users");

      if (!user.viewALL) {
        if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
          const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
          const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          if (uids.length > 1) {
            query = query.where('uidShipper', 'in', uids);
          } else {
            query = query.where('uidShipper', '==', user.uidShipper);
          }
        } else {
          query = query.where('uidShipper', '==', user.uidShipper);
        }
      }

      const snapshot = await query.get();
      const driversList = [];

      for (const doc of snapshot.docs) {
        try {
          const driverData = {
            id: doc.id,
            ...doc.data(),
          };

          // Busca dados adicionais do motorista
          const allDataRef = firebase
            .firestore()
            .collection("drivers_users")
            .doc(doc.id)
            .collection("documents")
            .doc("allData");

          const allDataSnapshot = await allDataRef.get();

          if (allDataSnapshot.exists) {
            const extraData = allDataSnapshot.data();
            const personal = extraData?.personalData || {};
            driverData.name = personal.fullName || driverData.name || "";
            driverData.cpf = personal.documentCpf || driverData.cpf || "";
          }

          driversList.push(driverData);
        } catch (err) {
          console.error(`Erro ao processar motorista ${doc.id}:`, err);
        }
      }

      setDrivers(dedupeById(driversList));
    } catch (err) {
      console.error("Erro ao carregar motoristas:", err);
    }
  };

  const loadFreights = async () => {
    try {
      let query = firebase.firestore().collection("freight");

      if (!user.viewALL) {
        if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
          const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
          const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          if (uids.length > 1) {
            query = query.where('clientPayment.uid', 'in', uids);
          } else {
            query = query.where('clientPayment.uid', '==', user.uidShipper);
          }
        } else {
          query = query.where('clientPayment.uid', '==', user.uidShipper);
        }
      }

      const snapshot = await query.get();
      const freightsList = snapshot.docs.map((doc) => {
        const data = doc.data();
        return {
          id: doc.id,
          ...data,
          label: data.numberSerial || "", // Para exibição no Autocomplete
        };
      });

      const uniqueFreights = dedupeById(freightsList);
      setFreights(uniqueFreights);
      setAllFreights(uniqueFreights); // Salva lista completa
    } catch (err) {
      console.error("Erro ao carregar fretes:", err);
    }
  };

  const loadShippers = async () => {
    try {
      if (user.viewALL) {
        const result = await firebase.firestore().collection("shipper").get();
        const shippersList = result.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          label: doc.data().dataPersonal.nameFantasy || doc.data().dataPersonal.socialName || doc.id,
        }));
        const uniqueShippers = dedupeById(shippersList);
        setShippers(uniqueShippers);
        setAllShippers(uniqueShippers); // Salva lista completa
      } else {
        if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
          const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
          const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          const shippersList = [];
          for (const uid of uids) {
            try {
              const docRef = firebase.firestore().collection("shipper").doc(uid);
              const docSnap = await docRef.get();

              if (docSnap.exists) {
                shippersList.push({
                  id: docSnap.id,
                  ...docSnap.data(),
                  label: docSnap.data().dataPersonal.nameFantasy || docSnap.data().dataPersonal.socialName || docSnap.id,
                });
              }
            } catch (err) {
              console.error(`Erro ao buscar shipper ${uid}:`, err);
            }
          }
          const uniqueShippers = dedupeById(shippersList);
          setShippers(uniqueShippers);
          setAllShippers(uniqueShippers); // Salva lista completa
        } else {
          const result = await firebase.firestore().collection("shipper").doc(user.uidShipper).get();
          if (result.exists) {
            const shippersList = [{
              id: result.id,
              ...result.data(),
              label: result.data().dataPersonal.nameFantasy || result.data().dataPersonal.socialName || result.id,
            }];
            const uniqueShippers = dedupeById(shippersList);
            setShippers(uniqueShippers);
            setAllShippers(uniqueShippers); // Salva lista completa
          }
        }
      }
    } catch (err) {
      console.error("Erro ao carregar embarcadores:", err);
    }
  };

  // Função para carregar fretes e embarcadores relacionados ao motorista selecionado
  const loadDriverRelatedData = async (driverId) => {
    if (!driverId) {
      // Se não há motorista selecionado, restaura as listas completas
      // Se as listas completas ainda não foram carregadas, recarrega
      if (allFreights.length === 0) {
        await loadFreights();
      } else {
        setFreights(allFreights);
      }
      
      if (allShippers.length === 0) {
        await loadShippers();
      } else {
        setShippers(allShippers);
      }
      return;
    }

    try {
      // Busca todos os fretes relacionados ao motorista
      let query = firebase.firestore().collection("freight")
        .where('freight.getDriverFreight.uidDriver', '==', driverId);

      const snapshot = await query.get();
      const relatedFreights = [];
      const shipperIds = new Set();

      snapshot.docs.forEach((doc) => {
        const data = doc.data();
        
        // Verifica permissões se necessário
        if (!user.viewALL) {
          const shipperUid = data?.clientPayment?.uid;
          if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
            const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
            const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
            const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));
            
            if (!uids.includes(shipperUid)) {
              return; // Pula este frete se não tiver permissão
            }
          } else {
            if (shipperUid !== user.uidShipper) {
              return; // Pula este frete se não tiver permissão
            }
          }
        }

        relatedFreights.push({
          id: doc.id,
          ...data,
          label: data.numberSerial || data.number_collect || doc.id,
        });

        // Coleta os IDs dos embarcadores relacionados
        const shipperUid = data?.clientPayment?.uid;
        if (shipperUid) {
          shipperIds.add(shipperUid);
        }
      });

      // Atualiza a lista de fretes com apenas os relacionados ao motorista
      setFreights(relatedFreights);

      // Busca os embarcadores relacionados
      if (shipperIds.size > 0) {
        const shipperArray = Array.from(shipperIds);
        const relatedShippers = [];

        // Busca cada embarcador
        for (const shipperId of shipperArray) {
          try {
            const docRef = firebase.firestore().collection("shipper").doc(shipperId);
            const docSnap = await docRef.get();

            if (docSnap.exists) {
              relatedShippers.push({
                id: docSnap.id,
                ...docSnap.data(),
                label: docSnap.data().dataPersonal.nameFantasy || docSnap.data().dataPersonal.socialName || docSnap.id,
              });
            }
          } catch (err) {
            console.error(`Erro ao buscar shipper ${shipperId}:`, err);
          }
        }

        setShippers(relatedShippers);
      } else {
        // Se não há embarcadores relacionados, limpa a lista
        setShippers([]);
      }
    } catch (err) {
      console.error("Erro ao carregar dados relacionados ao motorista:", err);
      // Em caso de erro, restaura as listas completas
      setFreights(allFreights);
      setShippers(allShippers);
    }
  };

  const loadTablesData = async () => {
    setLoading(true);
    setError(null);
    try {
      const tablesData = await Promise.all(
        AVAILABLE_TABLES.map(async (table) => {
          try {
            // Busca um documento de exemplo para descobrir os campos
            const snapshot = await firebase
              .firestore()
              .collection(table.collection)
              .limit(1)
              .get();

            let fields = [];
            if (!snapshot.empty) {
              const docData = snapshot.docs[0].data();
              fields = extractFields(docData, "");
            }

            return {
              ...table,
              fields: fields,
              loaded: true,
            };
          } catch (err) {
            console.error(`Erro ao carregar tabela ${table.name}:`, err);
            return {
              ...table,
              fields: [],
              loaded: false,
            };
          }
        })
      );

      

      setTables(tablesData);
    } catch (err) {
      setError("Erro ao carregar dados das tabelas: " + err.message);
      console.error("Erro ao carregar tabelas:", err);
    } finally {
      setLoading(false);
    }
  };

  // Função recursiva para extrair campos de objetos aninhados
  const extractFields = (
    obj,
    prefix = "",
    preferCreateData = Object.prototype.hasOwnProperty.call(obj || {}, "createData")
  ) => {
    const fields = [];
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        const value = obj[key];

        // Prioriza createData; só usa history.initialDate se createData não existir
        if (preferCreateData && fullKey === "history.initialDate") {
          continue;
        }

        if (shouldHideField(fullKey)) {
          continue;
        }

        if (value === null || value === undefined) {
          fields.push({
            id: fullKey,
            name: key,
            fullPath: fullKey,
            type: "null",
            displayName: toOptionLabel(translateFieldName(fullKey)),
          });
        } else if (isTimestampObject(value)) {
          // Mantém timestamps como campo único (evita exibir seconds/nanoseconds)
          fields.push({
            id: fullKey,
            name: key,
            fullPath: fullKey,
            type: "date",
            displayName: toOptionLabel(translateFieldName(fullKey)),
          });
        } else if (typeof value === "object" && !Array.isArray(value) && !(value instanceof Date)) {
          // Objeto aninhado - recursão
          fields.push(...extractFields(value, fullKey, preferCreateData));
        } else {
          fields.push({
            id: fullKey,
            name: key,
            fullPath: fullKey,
            type: Array.isArray(value) ? "array" : typeof value,
            displayName: toOptionLabel(translateFieldName(fullKey)),
            // displayName: formatFieldName(key),
          });
          // Campo simples
        }
      }
    }
    return fields;
  };


  const fallbackFieldLabel = (value) => {
    if (!value) return value;

    return String(value)
      .split(".")
      .filter(Boolean)
      .map((part) =>
        part
          .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
          .replace(/[_-]+/g, " ")
          .trim()
      )
      .join(" ")
      .replace(/\s+/g, " ")
      .trim();
  };

  const isTimestampObject = (value) => {
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    const hasFirestoreShape =
      typeof value.seconds === "number" && typeof value.nanoseconds === "number";
    const hasUnderscoreShape =
      typeof value._seconds === "number" && typeof value._nanoseconds === "number";
    return hasFirestoreShape || hasUnderscoreShape;
  };

  const HIDDEN_FIELD_PATHS = new Set([
    "createData.seconds",
    "createData.nanoseconds",
    "createData._seconds",
    "createData._nanoseconds",
    "history.initialDate.seconds",
    "history.initialDate.nanoseconds",
    "history.initialDate._seconds",
    "history.initialDate._nanoseconds",
    "user.uid",
    "clientPayment.uid",
    "shipper.uid",
    "history.partiallyDate",
    "history.initialDateContrate",
    "history.initialDate.nanoseconds",
    "history.initialDate.seconds",
    "history.atAnaliseDateDriver",
    "history.atAnaliseDate",
  ]);

  const shouldHideField = (fieldPath) => HIDDEN_FIELD_PATHS.has(fieldPath);

  const translateFieldName = (name) => {
    switch (name) {
      case "clientPayment.corporateName":
        return "Embarcador";
      case "clientPayment.cnpj":
        return "Cnpj Embarcador";
      case "createData":
      case "history.initialDate":
        return "Data de criação";
      case "driver.paymentCondition":
        return "Forma de pagamento";
      case "driver.valueInitial":
        return "Valor inicial";
      case "driver.valueFinal":
        return "Valor final";
      case "driver.valueNegotiated":
        return "Valor Negociado";
      case "firstDelivery.address":
        return "Endereço de Coleta";
      case "firstDelivery.cep":
        return "CEP da coleta";
      case "firstDelivery.city":
        return "Cidade da Coleta";
      case "firstDelivery.dateColeta":
        return "Data da coleta";
      case "firstDelivery.name":
        return "Cliente da coleta";
      case "firstDelivery.uf":
        return "UF da coleta";
      case "lastDelivery.address":
        return "Endereço de Entrega";
      case "lastDelivery.cep":
        return "CEP de Entrega";
      case "lastDelivery.city":
        return "Cidade de Entrega";
      case "lastDelivery.dateColeta":
        return "Data de Entrega";
      case "lastDelivery.name":
        return "Cliente de Entrega";
      case "lastDelivery.uf":
        return "UF de Entrega";
      case "freight.getDriverFreight.uidDriver":
        return "Motorista";
      case "freight.internalObservations":
        return "Observação interna";
      case "freight.observation":
        return "Observação";
      case "freight.phoneRespContractFreigtage":
        return "Fone Responsável";
      case "freight.seller":
        return "Vendedor";
      case "freight.totalAmountRoute":
        return "Distância";
      case "freight.userConfirmDriver":
        return "Usuario confirmação";
      case "freight.valueFreightage":
        return "Valor do frete";
      case "freight.valueNF":
        return "Valor da NF";
      case "freight.weightCargo":
        return "Peso da carga";
      case "status.describe":
        return "Status do frete";
      case "numberSerial":
        return "Número do frete";
      case "user.name":
        return "Nome do usuário";
      case "vehicle.freeOfCharge":
        return "Livre de carga";
      case "vehicle.occupation":
        return "Ocupação";
      case "vehicle.typeBodywork.dados":
        return "Tipo de Carroceria";
      case "vehicle.typeVehicle.dados":
        return "Tipo de veículo";
      case "history.dateFinished":
        return "Data de finalização";
      case "history.dateUpdate":
        return "Data de atualização";
      case "createUser":
        return "Usuario criação";
      case "lastDelivery.coordinates.latitude":
        return "latitude entrega";
    case "lastDelivery.coordinates.longitude":
        return "Longitude entrega";
      case "firstDelivery.coordinates.latitude":
        return "Latitude coleta";
      case "firstDelivery.coordinates.longitude":
        return "Longitude coleta";
      case "clientPayment.name":
        return "Nome do cliente";
      case "freight.newProducts":
        return "Novos produtos";
      case "freight.product":
        return "Produto";
      case "shipper.name":
        return "Nome do embarcador";
      case "status.code":
        return "Código do status";
      // Motoristas (drivers_users)
      case "accountCreated":
        return "Data de cadastro";
      case "cpf":
        return "CPF";
      case "email":
        return "E-mail";
      case "groups":
        return "Grupos";
      case "idNotification":
        return "ID de notificação";
      case "lastLogin":
        return "Último acesso";
      case "name":
        return "Nome";
      case "permissionToEdit":
        return "Permissão de edição";
      case "statusDriver":
        return "Status do motorista";
      case "uid":
        return "UID";
      case "uidShipper":
        return "UID embarcador";
      // Pagamentos (payment)
      case "dataBaixa":
      case "datePaid":
        return "Data baixa";
      case "dataValidade":
      case "dueDate":
      case "expirationDate":
        return "Data validade";
      case "desconto":
      case "discount":
        return "Desconto";
      case "driver":
        return "Motorista";
      case "idFreight":
      case "freightId":
        return "ID frete";
      case "obs":
      case "observation":
      case "observations":
        return "Observação";
      case "order":
        return "Ordem";
      case "status":
        return "Status";
      case "type":
        return "Tipo";
      case "valorAdicional":
      case "additionalValue":
        return "Valor adicional";
      case "value":
        return "Valor";
      case "valueTotal":
      case "totalValue":
        return "Valor total";
      default:
        return fallbackFieldLabel(name);
    }

  };

  const handleTableExpand = (tableId) => {
    setExpandedTable(expandedTable === tableId ? null : tableId);
  };

  const handleTableSearchChange = (tableId, value) => {
    setTableSearchTerms((prev) => ({
      ...prev,
      [tableId]: value,
    }));
  };

  const activeTableCollection =
    selectedFields.length > 0 ? selectedFields[0].tableCollection : null;

  const isTableLocked = (tableCollection) =>
    Boolean(activeTableCollection && tableCollection !== activeTableCollection);

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    const fieldId = parseFieldIdFromDraggable(draggableId);

    // Reordenar apenas dentro de "Campos Selecionados" (ids únicos com prefixo sel__)
    if (
      source.droppableId === "selected-fields" &&
      destination.droppableId === "selected-fields"
    ) {
      const newSelectedFields = Array.from(selectedFields);
      const [removed] = newSelectedFields.splice(source.index, 1);
      newSelectedFields.splice(destination.index, 0, removed);

      const reorderedFields = newSelectedFields.map((field, index) => ({
        ...field,
        order: index,
      }));

      setSelectedFields(reorderedFields);
      return;
    }

    // Adicionar da lista de tabelas para selecionados (não misturar com reordenação)
    if (
      destination.droppableId === "selected-fields" &&
      source.droppableId !== "selected-fields"
    ) {
      const fieldAlreadySelected = selectedFields.find((field) => field.id === fieldId);

      if (!fieldAlreadySelected) {
        const field = findFieldById(fieldId);
        if (field) {
          if (activeTableCollection && field.tableCollection !== activeTableCollection) {
            return;
          }
          setSelectedFields([...selectedFields, { ...field, order: selectedFields.length }]);
        }
      }
    }
  };

  const findFieldById = (fieldId) => {
    for (const table of tables) {
      const field = table.fields.find((f) => f.id === fieldId);
      if (field) {
        return { ...field, tableName: table.name, tableCollection: table.collection };
      }
    }
    return null;
  };

  const removeSelectedField = (fieldId) => {
    setSelectedFields(selectedFields.filter((field) => field.id !== fieldId));
  };

  // Função genérica para buscar dados das tabelas
  const fetchReportData = async () => {
    if (selectedFields.length === 0) {
      throw new Error("Selecione pelo menos um campo para gerar o relatório!");
    }

    // Agrupa campos por tabela
    const fieldsByTable = {};
    selectedFields.forEach((field) => {
      if (!fieldsByTable[field.tableCollection]) {
        fieldsByTable[field.tableCollection] = [];
      }
      fieldsByTable[field.tableCollection].push(field);
    });

    // Busca dados de cada tabela
    const allData = [];
    for (const [collection, fields] of Object.entries(fieldsByTable)) {
      try {
        let query = firebase.firestore().collection(collection);

        // Aplica filtros de permissão do usuário se necessário
        if (collection === "freight" && !user.viewALL) {
          if (user?.uidShipperAffiliates && Array.isArray(user.uidShipperAffiliates)) {
            const affiliateUids = Array.isArray(user?.uidShipperAffiliates) ? user.uidShipperAffiliates : [];
            const primaryUid = user?.uidShipper ? [user.uidShipper] : [];
            const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));
            
            if (uids.length > 1) {
              query = query.where('clientPayment.uid', 'in', uids);
            } else {
              query = query.where('clientPayment.uid', '==', user.uidShipper);
            }
          } else {
            query = query.where('clientPayment.uid', '==', user.uidShipper);
          }
        }

        // Aplica filtros selecionados pelo usuário
        if (selectedFreight && collection === "freight") {
          // Filtra por frete específico - busca diretamente pelo ID
          const docRef = firebase.firestore().collection(collection).doc(selectedFreight.id);
          const docSnap = await docRef.get();
          if (docSnap.exists) {
            let docData = { id: docSnap.id, ...docSnap.data() };
            
            // Aplica filtro de motorista se necessário
            if (selectedDriver) {
              const driverUid = docData?.freight?.getDriverFreight?.uidDriver;
              if (driverUid !== selectedDriver.id) {
                continue; // Pula se o motorista não corresponder
              }
            }

            if (!matchesDateFilter(docData)) {
              continue; // Pula se a data não corresponder
            }
            
            allData.push({
              collection,
              fields,
              data: [docData],
            });
          }
          continue; // Pula para o próximo loop
        }

        if (selectedShipper) {
          // Filtra por embarcador
          if (collection === "freight") {
            query = query.where('clientPayment.uid', '==', selectedShipper.id);
          } else if (collection === "shipper") {
            // Busca embarcador específico
            const docRef = firebase.firestore().collection(collection).doc(selectedShipper.id);
            const docSnap = await docRef.get();
            if (docSnap.exists) {
              const shipperDoc = { id: docSnap.id, ...docSnap.data() };
              if (!matchesDateFilter(shipperDoc)) {
                continue;
              }
              allData.push({
                collection,
                fields,
                data: [shipperDoc],
              });
            }
            continue; // Pula para o próximo loop
          }
        }

        const snapshot = await query.get();
        let docs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Aplica filtro de motorista após buscar os dados
        if (selectedDriver) {
          if (collection === "freight") {
            // Filtra por motorista nos fretes
            docs = docs.filter((doc) => {
              const driverUid = doc?.freight?.getDriverFreight?.uidDriver;
              return driverUid === selectedDriver.id;
            });
          } else {
            // Para outras coleções, filtra se tiverem referência ao motorista
            docs = docs.filter((doc) => {
              // Verifica se o documento tem referência ao motorista
              if (doc.driver === selectedDriver.id || doc.uidDriver === selectedDriver.id) {
                return true;
              }
              return false;
            });
          }
        }

        if (hasActiveDateFilter) {
          docs = docs.filter((doc) => matchesDateFilter(doc));
        }

        allData.push({
          collection,
          fields,
          data: docs,
        });
      } catch (err) {
        console.error(`Erro ao buscar dados de ${collection}:`, err);
      }
    }

    return allData;
  };

  const generateReport = async () => {
    if (selectedFields.length === 0) {
      alert("Selecione pelo menos um campo para gerar o relatório!");
      return;
    }

    if (!ensureDateFilterReady()) {
      return;
    }

    setLoading(true);
    try {
      const allData = await fetchReportData();
      // Gera o PDF
      generatePDF(allData);
    } catch (err) {
      setError("Erro ao gerar relatório: " + err.message);
      console.error("Erro ao gerar relatório:", err);
    } finally {
      setLoading(false);
    }
  };

  const generatePDF = (dataByTable) => {
    // Inicializa os fonts do pdfmake (igual ao exemplo que funciona)
    // Sempre tenta usar pdfFonts.pdfMake.vfs primeiro
    try {
      if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      } else if (pdfFonts && typeof pdfFonts === 'object') {
        // Se pdfFonts já é o vfs diretamente, tenta criar a estrutura esperada
        if (pdfFonts['Roboto-Regular.ttf']) {
          // Cria a estrutura que o pdfmake espera
          pdfMake.vfs = pdfFonts;
        } else {
          throw new Error("pdfFonts não contém estrutura de fonts válida");
        }
      } else {
        throw new Error("Estrutura de fonts não reconhecida");
      }
    } catch (error) {
      console.error("Erro ao inicializar pdfmake:", error);
      setError("Erro ao inicializar o gerador de PDF: " + error.message);
      return;
    }

    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    // Cabeçalho do relatório
    const reportHeader = [
      {
        text: reportTitle,
        fontSize: 18,
        bold: false, // Evita usar Roboto-Medium
        margin: [0, 0, 0, 10],
        alignment: "center",
      },
      {
        text: `Data de geração: ${formattedDate}`,
        fontSize: 10,
        margin: [0, 0, 0, 20],
        alignment: "center",
      },
    ];

    // Conteúdo do relatório
    const content = [];

    // Se houver apenas uma tabela, mescla todos os campos em uma única tabela
    if (dataByTable.length === 1) {
      const { fields, data } = dataByTable[0];
      if (data.length === 0) {
        content.push({
          text: "Nenhum dado encontrado para os critérios selecionados.",
          fontSize: 12,
          margin: [0, 20, 0, 10],
        });
      } else {
        // Cabeçalho da tabela
        const tableHeaders = fields
          .sort((a, b) => (a.order || 0) - (b.order || 0))
          .map((field) => ({
            text: field.displayName,
            style: "tableHeader",
          }));

        // Dados da tabela
        const tableRows = data.map((doc) => {
          return fields
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((field) => {
              const value = getNestedValue(doc, field.fullPath);
              return formatValueForPDF(value);
            });
        });

        // Tabela no PDF
        content.push({
          table: {
            headerRows: 1,
            widths: fields.map(() => "*"),
            body: [tableHeaders, ...tableRows],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 1 : 0.5;
            },
            vLineWidth: function (i, node) {
              return 0.5;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === node.table.body.length ? "#000000" : "#cccccc";
            },
            vLineColor: function () {
              return "#cccccc";
            },
          },
          margin: [0, 0, 0, 20],
        });
      }
    } else {
      // Múltiplas tabelas - mostra cada uma em uma seção separada
      dataByTable.forEach(({ collection, fields, data }) => {
        if (data.length === 0) return;

        // Título da seção
        content.push({
          text: AVAILABLE_TABLES.find((t) => t.collection === collection)?.name || collection,
          fontSize: 14,
          bold: false, // Evita usar Roboto-Medium
          margin: [0, 20, 0, 10],
        });

        // Cabeçalho da tabela
        const tableHeaders = fields
          .sort((a, b) => (a.order || 0) - (b.order || 0))
          .map((field) => ({
            text: field.displayName,
            style: "tableHeader",
          }));

        // Dados da tabela
        const tableRows = data.map((doc) => {
          return fields
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((field) => {
              const value = getNestedValue(doc, field.fullPath);
              return formatValueForPDF(value);
            });
        });

        // Tabela no PDF
        content.push({
          table: {
            headerRows: 1,
            widths: fields.map(() => "*"),
            body: [tableHeaders, ...tableRows],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 1 : 0.5;
            },
            vLineWidth: function (i, node) {
              return 0.5;
            },
            hLineColor: function (i, node) {
              return i === 0 || i === node.table.body.length ? "#000000" : "#cccccc";
            },
            vLineColor: function () {
              return "#cccccc";
            },
          },
          margin: [0, 0, 0, 20],
        });
      });
    }

    // Rodapé
    const footer = (currentPage, pageCount) => {
      return {
        text: `Página ${currentPage} de ${pageCount}`,
        alignment: "right",
        fontSize: 9,
        margin: [0, 10, 20, 0],
      };
    };

    const docDefinition = {
      pageSize: "A4",
      pageMargins: [40, 60, 40, 60],
      header: reportHeader,
      content: content,
      footer: footer,
      styles: {
        tableHeader: {
          bold: false,
          fontSize: 10,
          color: "#000000",
          fillColor: "#f0f0f0",
        },
      },
    };

    pdfMake.createPdf(docDefinition).open();
  };

  const formatValueForPDF = (value) => {
    if (value === null || value === undefined) {
      return "-";
    }
    if (value instanceof Date) {
      return value.toLocaleDateString("pt-BR");
    }
    if (typeof value?.toDate === "function") {
      const d = value.toDate();
      if (!Number.isNaN(d.getTime())) {
        return d.toLocaleDateString("pt-BR");
      }
    }
    if (isTimestampObject(value)) {
      const sec = value.seconds ?? value._seconds;
      const d = new Date(sec * 1000);
      if (!Number.isNaN(d.getTime())) {
        return d.toLocaleDateString("pt-BR");
      }
    }
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      const [y, m, day] = value.trim().split("-");
      return `${day}/${m}/${y}`;
    }
    if (typeof value === "object") {
      return JSON.stringify(value);
    }
    if (typeof value === "boolean") {
      return value ? "Sim" : "Não";
    }
    return String(value);
  };

  /** Exportação CSV/XLS: tipos nativos no Excel; CSV sem aspas em números. */
  const getExportCell = (value, field) => {
    const ft = field?.type;
    if (value === null || value === undefined) {
      return { xlsx: "", csv: "", csvQuoted: true };
    }

    if (ft === "boolean" || typeof value === "boolean") {
      const text = value ? "Sim" : "Não";
      return { xlsx: text, csv: text, csvQuoted: true };
    }

    if (ft === "number" || typeof value === "number") {
      let n;
      if (typeof value === "number") {
        n = value;
      } else {
        const s = String(value).trim().replace(/\s/g, "");
        n = Number(s);
        if (Number.isNaN(n)) {
          n = parseFloat(s.replace(/\./g, "").replace(",", "."));
        }
      }
      if (!Number.isNaN(n)) {
        return { xlsx: n, csv: String(n), csvQuoted: false };
      }
    }

    let dateVal = null;
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      dateVal = value;
    } else if (typeof value?.toDate === "function") {
      const d = value.toDate();
      if (!Number.isNaN(d.getTime())) dateVal = d;
    } else if (isTimestampObject(value)) {
      const sec = value.seconds ?? value._seconds;
      const d = new Date(sec * 1000);
      if (!Number.isNaN(d.getTime())) dateVal = d;
    } else if (ft === "date" && typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      const [y, m, day] = value.trim().split("-");
      dateVal = new Date(Number(y), Number(m) - 1, Number(day));
    }

    if (dateVal && !Number.isNaN(dateVal.getTime())) {
      const csvText = dateVal.toLocaleDateString("pt-BR");
      return { xlsx: dateVal, csv: csvText, csvQuoted: true };
    }

    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value.trim())) {
      const [y, m, day] = value.trim().split("-");
      const d = new Date(Number(y), Number(m) - 1, Number(day));
      if (!Number.isNaN(d.getTime())) {
        return { xlsx: d, csv: d.toLocaleDateString("pt-BR"), csvQuoted: true };
      }
    }

    if (typeof value === "object") {
      const s = JSON.stringify(value);
      return { xlsx: s, csv: s, csvQuoted: true };
    }

    const s = String(value);
    return { xlsx: s, csv: s, csvQuoted: true };
  };

  const exportToCSV = async () => {
    if (selectedFields.length === 0) {
      alert("Selecione pelo menos um campo para exportar!");
      return;
    }
    if (!ensureDateFilterReady()) {
      return;
    }

    setLoading(true);
    try {
      const allData = await fetchReportData();
      
      // Prepara os dados para CSV
      let csvContent = "";
      
      allData.forEach(({ collection, fields, data }) => {
        if (data.length === 0) return;

        // Adiciona título da seção
        const tableName = AVAILABLE_TABLES.find((t) => t.collection === collection)?.name || collection;
        csvContent += `\n${tableName}\n`;

        // Cabeçalho
        const headers = fields
          .sort((a, b) => (a.order || 0) - (b.order || 0))
          .map((field) => field.displayName);
        csvContent += headers.join(";") + "\n";

        // Dados
        data.forEach((doc) => {
          const row = fields
            .sort((a, b) => (a.order || 0) - (b.order || 0))
            .map((field) => {
              const value = getNestedValue(doc, field.fullPath);
              const cell = getExportCell(value, field);
              if (!cell.csvQuoted) {
                return cell.csv;
              }
              return `"${cell.csv.replace(/"/g, '""')}"`;
            });
          csvContent += row.join(";") + "\n";
        });

        csvContent += "\n";
      });

      // Cria e baixa o arquivo
      const blob = new Blob(["\ufeff" + csvContent], { type: "text/csv;charset=utf-8;" }); // BOM para Excel
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `${reportTitle.replace(/\s+/g, "_")}_${new Date().toISOString().split("T")[0]}.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      setError("Erro ao exportar CSV: " + err.message);
      console.error("Erro ao exportar CSV:", err);
    } finally {
      setLoading(false);
    }
  };

  const exportToXLS = async () => {
    if (selectedFields.length === 0) {
      alert("Selecione pelo menos um campo para exportar!");
      return;
    }
    if (!ensureDateFilterReady()) {
      return;
    }

    setLoading(true);
    try {
      const allData = await fetchReportData();
      
      // Cria um workbook
      const workbook = XLSX.utils.book_new();

      allData.forEach(({ collection, fields, data }) => {
        if (data.length === 0) return;

        const tableName = AVAILABLE_TABLES.find((t) => t.collection === collection)?.name || collection;
        
        // Prepara os dados
        const sortedFields = fields.sort((a, b) => (a.order || 0) - (b.order || 0));
        
        // Cabeçalho
        const headers = sortedFields.map((field) => field.displayName);
        
        // Dados
        const rows = data.map((doc) => {
          return sortedFields.map((field) => {
            const value = getNestedValue(doc, field.fullPath);
            return getExportCell(value, field).xlsx;
          });
        });

        // Cria a worksheet
        const worksheetData = [headers, ...rows];
        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Ajusta largura das colunas
        const colWidths = sortedFields.map(() => ({ wch: 20 }));
        worksheet["!cols"] = colWidths;

        // Adiciona a worksheet ao workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, tableName.substring(0, 31)); // Excel limita a 31 caracteres
      });

      // Gera o arquivo e faz download
      const fileName = `${reportTitle.replace(/\s+/g, "_")}_${new Date().toISOString().split("T")[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } catch (err) {
      setError("Erro ao exportar XLS: " + err.message);
      console.error("Erro ao exportar XLS:", err);
    } finally {
      setLoading(false);
    }
  };

  const persistSavedReports = (next) => {
    if (!user?.uid) return;
    try {
      localStorage.setItem(`${user.uid}:${SAVED_REPORTS_STORAGE_SUFFIX}`, JSON.stringify(next));
      setSavedReports(next);
    } catch (e) {
      console.error("Erro ao salvar relatórios:", e);
      setError("Não foi possível salvar os relatórios.");
    }
  };

  const buildSavedReportConfig = () => ({
    reportTitle,
    selectedFields: selectedFields.map((f) => ({
      id: f.id,
      fullPath: f.fullPath,
      tableCollection: f.tableCollection,
      tableName: f.tableName,
      displayName: f.displayName,
      type: f.type,
      order: f.order,
      name: f.name,
    })),
    filters: {
      selectedDriver: selectedDriver
        ? {
            id: selectedDriver.id,
            name: selectedDriver.name,
            cpf: selectedDriver.cpf,
          }
        : null,
      selectedFreight: selectedFreight
        ? {
            id: selectedFreight.id,
            label: selectedFreight.label,
            numberSerial: selectedFreight.numberSerial,
            number_collect: selectedFreight.number_collect,
          }
        : null,
      selectedShipper: selectedShipper
        ? {
            id: selectedShipper.id,
            label: selectedShipper.label,
            corporateName: selectedShipper.corporateName,
            nameFantasy: selectedShipper.nameFantasy,
            socialName: selectedShipper.socialName,
          }
        : null,
      selectedDateOperator,
      selectedDate,
      selectedDateEnd,
    },
  });

  const mergeSavedFieldsIntoCurrentTables = (savedFields) => {
    const list = [...(savedFields || [])].sort((a, b) => (a.order || 0) - (b.order || 0));
    const merged = [];
    let dropped = 0;
    for (const sf of list) {
      const current = findFieldById(sf.id);
      if (current) {
        merged.push({
          ...current,
          order: sf.order,
          displayName: sf.displayName || current.displayName,
        });
      } else {
        dropped += 1;
      }
    }
    return { merged, dropped };
  };

  const applySavedReport = async (entry) => {
    const cfg = entry?.config;
    if (!cfg) return;
    setReportTitle(cfg.reportTitle || "Relatório Dinâmico");
    const { merged, dropped } = mergeSavedFieldsIntoCurrentTables(cfg.selectedFields || []);
    setSelectedFields(merged);
    if (dropped > 0) {
      setSavedReportNotice(
        `${dropped} campo(s) do layout não existem mais nas tabelas e foram ignorados.`
      );
    } else {
      setSavedReportNotice(null);
    }
    const filters = cfg.filters;
    if (filters) {
      setSelectedDateOperator(filters.selectedDateOperator || "equals");
      setSelectedDate(filters.selectedDate || "");
      setSelectedDateEnd(filters.selectedDateEnd || "");
      setSelectedDriver(filters.selectedDriver || null);
      await loadDriverRelatedData(filters.selectedDriver?.id || null);
      setSelectedFreight(filters.selectedFreight || null);
      setSelectedShipper(filters.selectedShipper || null);
    }
    setSavedReportsMenuAnchor(null);
  };

  const handleSaveReportConfirm = () => {
    const name = (saveReportNameInput || "").trim();
    if (!name) {
      alert("Informe um nome para o relatório.");
      return;
    }
    if (!user?.uid) {
      alert("É necessário estar logado para salvar.");
      return;
    }
    const entry = {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
      name,
      createdAt: new Date().toISOString(),
      config: buildSavedReportConfig(),
    };
    persistSavedReports([...savedReports, entry]);
    setSaveReportDialogOpen(false);
    setSaveReportNameInput("");
  };

  const deleteSavedReport = (id, event) => {
    if (event) event.stopPropagation();
    persistSavedReports(savedReports.filter((r) => r.id !== id));
  };

  const canViewGeneralReport = user?.permissoes?.generalReport?.isView === true;

  if (userLogado <= 0) {
    return <Navigate to="/login" />;
  }

  if (!canViewGeneralReport) {
    return <Navigate to="/" replace />;
  }

  return (
    <NewMiniDrawer
      divOpen={
        <Box sx={pageLayoutSx}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: appTheme.typography.weightSemibold + 100,
              color: appTheme.colors.textPrimary,
              letterSpacing: appTheme.typography.letterSpacing,
            }}
            gutterBottom
          >
            Relatório Dinâmico
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: appTheme.colors.textSecondary, mb: 1, maxWidth: 720 }}
            gutterBottom
          >
            Selecione os campos arrastando-os para a área de seleção e gere seu relatório personalizado
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mt: 2, mb: 2 }} onClose={() => setError(null)}>
              {error}
            </Alert>
          )}

          {savedReportNotice && (
            <Alert severity="info" sx={{ mt: 2, mb: 2 }} onClose={() => setSavedReportNotice(null)}>
              {savedReportNotice}
            </Alert>
          )}

          <Dialog open={saveReportDialogOpen} onClose={() => setSaveReportDialogOpen(false)} fullWidth maxWidth="xs">
            <DialogTitle>Salvar relatório personalizado</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                label="Nome do relatório"
                fullWidth
                value={saveReportNameInput}
                onChange={(e) => setSaveReportNameInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSaveReportConfirm();
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setSaveReportDialogOpen(false)}>Cancelar</Button>
              <Button variant="contained" onClick={handleSaveReportConfirm}>
                Salvar
              </Button>
            </DialogActions>
          </Dialog>

          <Menu
            anchorEl={savedReportsMenuAnchor}
            open={Boolean(savedReportsMenuAnchor)}
            onClose={() => setSavedReportsMenuAnchor(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <MenuItem
              onClick={() => {
                setSaveReportDialogOpen(true);
                setSavedReportsMenuAnchor(null);
              }}
            >
              Salvar layout atual…
            </MenuItem>
            {savedReports.length > 0 && <Divider />}
            {savedReports.map((r) => (
              <MenuItem
                key={r.id}
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, pr: 1 }}
                onClick={() => void applySavedReport(r)}
              >
                <ListItemText
                  primary={r.name}
                  secondary={r.createdAt ? new Date(r.createdAt).toLocaleString("pt-BR") : ""}
                />
                <IconButton
                  size="small"
                  aria-label="Excluir relatório salvo"
                  onClick={(e) => deleteSavedReport(r.id, e)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </MenuItem>
            ))}
          </Menu>

          <Card sx={{ ...sectionCardSx, mt: 3, mb: 3 }}>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                <TuneIcon sx={{ color: appTheme.colors.highlight }} />
                <Typography variant="h6" sx={{ fontWeight: 700, color: appTheme.colors.primary }}>
                  Configuração e Filtros
                </Typography>
              </Box>

              <Box sx={{ display: "flex", gap: 2, alignItems: "flex-start", mb: 2, flexWrap: "wrap" }}>
                <TextField
                  label="Título do Relatório"
                  value={reportTitle}
                  onChange={(e) => setReportTitle(e.target.value)}
                  fullWidth
                  variant="outlined"
                  sx={{ flex: "1 1 240px", minWidth: 0, color: appTheme.colors.primary }}
                />
                <Button
                  variant="outlined"
                  startIcon={<BookmarkIcon sx={{ color: appTheme.colors.primary }} />}
                  onClick={(e) => setSavedReportsMenuAnchor(e.currentTarget)}
                  sx={{ flexShrink: 0, mt: 0.5, color: appTheme.colors.primary, borderColor: appTheme.colors.primary }}
                >
                  Relatórios salvos
                </Button>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                <FilterAltIcon fontSize="small" sx={{ color: appTheme.colors.highlight }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: appTheme.colors.primary }}>
                  Filtros da consulta
                </Typography>
              </Box>

              <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  options={drivers}
                  getOptionLabel={(option) =>
                    toOptionLabel(option?.name || option?.cpf || option?.id || "")
                  }
                  renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li
                        {...optionProps}
                        key={`driver-${option?.id || "no-id"}-${optionProps.id || key}`}
                      >
                        {toOptionLabel(option?.name || option?.cpf || option?.id || "")}
                      </li>
                    );
                  }}
                  value={selectedDriver}
                  onChange={async (event, newValue) => {
                    setSelectedDriver(newValue);
                    // Limpa os filtros de frete e embarcador quando mudar o motorista
                    setSelectedFreight(null);
                    setSelectedShipper(null);
                    // Carrega os fretes e embarcadores relacionados ao motorista selecionado
                    await loadDriverRelatedData(newValue?.id || null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Filtrar por Motorista"
                      variant="outlined"
                      placeholder="Selecione um motorista"
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  noOptionsText="Nenhum motorista encontrado"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  options={freights}
                  getOptionLabel={(option) =>
                    toOptionLabel(
                      option?.label ||
                        option?.numberSerial ||
                        option?.number_collect ||
                        ""
                    )
                  }
                  renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li
                        {...optionProps}
                        key={`freight-${option?.id || "no-id"}-${optionProps.id || key}`}
                      >
                        {toOptionLabel(
                          option?.label ||
                            option?.numberSerial ||
                            option?.number_collect ||
                            ""
                        )}
                      </li>
                    );
                  }}
                  value={selectedFreight}
                  onChange={(event, newValue) => setSelectedFreight(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Filtrar por Frete"
                      variant="outlined"
                      placeholder="Selecione um frete"
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  noOptionsText="Nenhum frete encontrado"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  options={shippers}
                  getOptionLabel={(option) =>
                    toOptionLabel(
                      option?.label ||
                        option?.nameFantasy ||
                        option?.socialName ||
                        option?.id ||
                        ""
                    )
                  }
                  renderOption={(props, option) => {
                    const { key, ...optionProps } = props;
                    return (
                      <li
                        {...optionProps}
                        key={`shipper-${option?.id || "no-id"}-${optionProps.id || key}`}
                      >
                        {toOptionLabel(
                          option?.label ||
                            option?.nameFantasy ||
                            option?.socialName ||
                            option?.id ||
                            ""
                        )}
                      </li>
                    );
                  }}
                  value={selectedShipper}
                  onChange={(event, newValue) => setSelectedShipper(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Filtrar por Embarcador"
                      variant="outlined"
                      placeholder="Selecione um embarcador"
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  noOptionsText="Nenhum embarcador encontrado"
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  select
                  label="Operador de Data"
                  value={selectedDateOperator}
                  onChange={(event) => {
                    const nextOperator = event.target.value;
                    setSelectedDateOperator(nextOperator);
                    if (nextOperator !== "between") {
                      setSelectedDateEnd("");
                    }
                  }}
                >
                  <MenuItem value="equals">Igual a</MenuItem>
                  <MenuItem value="before">Antes de</MenuItem>
                  <MenuItem value="after">Depois de</MenuItem>
                  <MenuItem value="between">Entre</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  type="date"
                  label={selectedDateOperator === "between" ? "Data Inicial" : "Data"}
                  value={selectedDate}
                  onChange={(event) => setSelectedDate(event.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              {selectedDateOperator === "between" && (
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    type="date"
                    label="Data Final"
                    value={selectedDateEnd}
                    onChange={(event) => setSelectedDateEnd(event.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              )}
            </Grid>

            {(selectedDriver ||
              selectedFreight ||
              selectedShipper ||
              selectedDate ||
              selectedDateEnd) && (
              <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap", alignItems: "center" }}>
                {selectedDriver && (
                  <Chip
                    label={`MOTORISTA: ${toOptionLabel(selectedDriver.name || selectedDriver.cpf || selectedDriver.id || "")}`}
                    onDelete={async () => {
                      setSelectedDriver(null);
                      // Restaura as listas completas quando remover o motorista
                      await loadDriverRelatedData(null);
                    }}
                    color="primary"
                    variant="outlined"
                  />
                )}
                {selectedFreight && (
                  <Chip
                    label={`FRETE: ${toOptionLabel(selectedFreight.numberSerial || selectedFreight.id || "")}`}
                    onDelete={() => setSelectedFreight(null)}
                    color="primary"
                    variant="outlined"
                  />
                )}
                {selectedShipper && (
                  <Chip
                    label={`EMBARCADOR: ${toOptionLabel(selectedShipper.label || selectedShipper.corporateName || selectedShipper.id || "")}`}
                    onDelete={() => setSelectedShipper(null)}
                    color="primary"
                    variant="outlined"
                  />
                )}
                {selectedDate && (
                  <Chip
                    label={`DATA: ${
                      selectedDateOperator === "between" && selectedDateEnd
                        ? `${toOptionLabel(selectedDate)} A ${toOptionLabel(selectedDateEnd)}`
                        : `${toOptionLabel(
                            selectedDateOperator === "equals"
                              ? "IGUAL A"
                              : selectedDateOperator === "before"
                                ? "ANTES DE"
                                : "DEPOIS DE"
                          )} ${toOptionLabel(selectedDate)}`
                    }`}
                    onDelete={() => {
                      setSelectedDate("");
                      setSelectedDateEnd("");
                      setSelectedDateOperator("equals");
                    }}
                    color="primary"
                    variant="outlined"
                  />
                )}
                {(selectedDriver ||
                  selectedFreight ||
                  selectedShipper ||
                  selectedDate ||
                  selectedDateEnd) && (
                  <Button
                    size="small"
                    variant="text"
                    color="secondary"
                    onClick={async () => {
                      setSelectedDriver(null);
                      setSelectedFreight(null);
                      setSelectedShipper(null);
                      setSelectedDateOperator("equals");
                      setSelectedDate("");
                      setSelectedDateEnd("");
                      // Restaura as listas completas quando limpar todos os filtros
                      await loadDriverRelatedData(null);
                    }}
                  >
                    Limpar Filtros
                  </Button>
                )}
              </Box>
            )}
            </CardContent>
          </Card>

          <DragDropContext onDragEnd={onDragEnd}>
            <Grid container spacing={3}>
              {/* Coluna esquerda - Lista de tabelas e campos */}
              <Grid item xs={12} md={6}>
                <Card sx={sectionCardSx}>
                  <CardContent>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <TableViewIcon sx={{ color: appTheme.colors.highlight }} />
                        <Typography variant="h6" sx={{ fontWeight: 700, color: appTheme.colors.primary }}>
                          Tabelas e Campos Disponíveis
                        </Typography>
                      </Box>
                      <IconButton onClick={loadTablesData} disabled={loading}>
                        <RefreshIcon sx={{ color: appTheme.colors.highlight }} />
                      </IconButton>
                    </Box>

                    {loading && (
                      <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                        <CircularProgress sx={{ color: appTheme.colors.highlight }} />
                      </Box>
                    )}

                    {!loading && (
                      <Box sx={{ maxHeight: "600px", overflowY: "auto" }}>
                        {activeTableCollection && (
                          <Alert severity="info" sx={{ mb: 2 }}>
                            Tabela ativa:{" "}
                            {tables.find((table) => table.collection === activeTableCollection)?.name ||
                              activeTableCollection}
                            . Limpe os campos selecionados para trocar de tabela.
                          </Alert>
                        )}
                        {tables.length === 0 ? (
                          <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 3 }}>
                            Nenhuma tabela encontrada. Clique no botão de atualizar para recarregar.
                          </Typography>
                        ) : (
                          tables.map((table) => {
                            const tableSearchTerm = (tableSearchTerms[table.id] || "").trim().toLowerCase();
                            const filteredTableFields = [...table.fields]
                              .sort((a, b) =>
                                (a.displayName || "").localeCompare(
                                  b.displayName || "",
                                  "pt-BR",
                                  { sensitivity: "base" }
                                )
                              )
                              .filter((field) => {
                                if (!tableSearchTerm) return true;
                                const displayName = (field.displayName || "").toLowerCase();
                                const fullPath = (field.fullPath || "").toLowerCase();
                                return (
                                  displayName.includes(tableSearchTerm) ||
                                  fullPath.includes(tableSearchTerm)
                                );
                              });

                            return (
                              <Accordion
                              key={table.id}
                              expanded={!isTableLocked(table.collection) && expandedTable === table.id}
                              onChange={() => {
                                if (!isTableLocked(table.collection)) {
                                  handleTableExpand(table.id);
                                }
                              }}
                              disabled={isTableLocked(table.collection)}
                              sx={{
                                opacity: isTableLocked(table.collection) ? 0.5 : 1,
                              }}
                            >
                              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="subtitle1">{table.name}</Typography>
                                <Typography variant="caption" sx={{ ml: 2, color: "text.secondary" }}>
                                  ({table.fields.length} campos)
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                {table.fields.length === 0 ? (
                                  <Typography variant="body2" color="text.secondary">
                                    Nenhum campo encontrado nesta tabela.
                                  </Typography>
                                ) : (
                                  <>
                                    <TextField
                                      fullWidth
                                      size="small"
                                      label="Buscar campo"
                                      placeholder="Buscar campo nesta tabela"
                                      value={tableSearchTerms[table.id] || ""}
                                      onChange={(event) =>
                                        handleTableSearchChange(table.id, event.target.value)
                                      }
                                      sx={{ mb: 2 }}
                                    />

                                    {filteredTableFields.length === 0 ? (
                                      <Typography variant="body2" color="text.secondary">
                                        Nenhum campo encontrado para esta busca.
                                      </Typography>
                                    ) : (
                                      <Droppable droppableId={`table-${table.id}`} isDropDisabled>
                                        {(provided) => (
                                          <Box
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
                                          >
                                            {filteredTableFields.map((field, index) => (
                                              <Draggable
                                                key={field.id}
                                                draggableId={poolDraggableId(field.id)}
                                                index={index}
                                                isDragDisabled={isTableLocked(table.collection)}
                                              >
                                                {(provided, snapshot) => (
                                                  <Chip
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    label={field.displayName}
                                                    size="small"
                                                    sx={{
                                                      cursor: isTableLocked(table.collection) ? "not-allowed" : "grab",
                                                      opacity: snapshot.isDragging ? 0.5 : 1,
                                                      backgroundColor: snapshot.isDragging
                                                        ? "#e3f2fd"
                                                        : "default",
                                                    }}
                                                  />
                                                )}
                                              </Draggable>
                                            ))}
                                            {provided.placeholder}
                                          </Box>
                                        )}
                                      </Droppable>
                                    )}
                                  </>
                                )}
                              </AccordionDetails>
                            </Accordion>
                            );
                          })
                        )}
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {/* Coluna direita - Campos selecionados */}
              <Grid item xs={12} md={6}>
                <Card sx={sectionCardSx}>
                  <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                      <PlaylistAddCheckIcon sx={{ color: appTheme.colors.highlight }} />
                      <Typography variant="h6" sx={{ fontWeight: 700, color: appTheme.colors.primary }}>
                        Campos Selecionados ({selectedFields.length})
                      </Typography>
                    </Box>

                    <Droppable droppableId="selected-fields">
                      {(provided, snapshot) => (
                        <Paper
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                          sx={{
                            minHeight: "400px",
                            p: 2,
                            backgroundColor: snapshot.isDraggingOver
                              ? "#e3f2fd"
                              : "#f5f5f5",
                            border: snapshot.isDraggingOver
                              ? "2px dashed #1976d2"
                              : "2px dashed #ccc",
                            borderRadius: 2,
                          }}
                        >
                          {selectedFields.length === 0 ? (
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              align="center"
                              sx={{ mt: 10 }}
                            >
                              Arraste os campos aqui para selecioná-los
                            </Typography>
                          ) : (
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                              {selectedFields
                                .sort((a, b) => (a.order || 0) - (b.order || 0))
                                .map((field, index) => (
                                  <Draggable
                                    key={field.id}
                                    draggableId={selDraggableId(field.id)}
                                    index={index}
                                  >
                                    {(provided, snapshot) => (
                                      <Paper
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        sx={{
                                          p: 1.5,
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          backgroundColor: snapshot.isDragging
                                            ? "#e3f2fd"
                                            : "white",
                                          boxShadow: snapshot.isDragging ? 3 : 1,
                                        }}
                                      >
                                        <Box>
                                          <Typography variant="body2" fontWeight="bold">
                                            {field.displayName}
                                          </Typography>
                                          <Typography variant="caption" color="text.secondary">
                                            {field.tableName} • {field.fullPath}
                                          </Typography>
                                        </Box>
                                        <IconButton
                                          size="small"
                                          onClick={() => removeSelectedField(field.id)}
                                          color="error"
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </Paper>
                                    )}
                                  </Draggable>
                                ))}
                            </Box>
                          )}
                          {provided.placeholder}
                        </Paper>
                      )}
                    </Droppable>

                    <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2, flexWrap: "wrap" }}>
                      <Box sx={{ mr: "auto", display: "flex", alignItems: "center", gap: 1 }}>
                        <DescriptionIcon fontSize="small" color="action" />
                        <Typography variant="body2" color="text.secondary">
                          Exportações
                        </Typography>
                      </Box>
                      <Button
                        variant="outlined"
                        color="success"
                        startIcon={<FileDownloadIcon />}
                        onClick={exportToCSV}
                        disabled={selectedFields.length === 0 || loading}
                        size="large"
                      >
                        Exportar CSV
                      </Button>
                      <Button
                        variant="outlined"
                        color="success"
                        startIcon={<TableChartIcon />}
                        onClick={exportToXLS}
                        disabled={selectedFields.length === 0 || loading}
                        size="large"
                      >
                        Exportar XLS
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<PictureAsPdfIcon />}
                        onClick={generateReport}
                        disabled={selectedFields.length === 0 || loading}
                        size="large"
                      >
                        Gerar Relatório PDF
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </DragDropContext>
        </Box>
      }
    />
  );
}

export default RelGeneral;

